<script>
export default {
    props: {
        value: {
            type: Object,
            required: false,
            default: () => ({})
        },
        editMode: {
            type: Boolean,
            required: false,
            default: false
        },
        validation: {
            type: Object,
            required: true
        },
        serverErrors: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            item: {}
        };
    },

    watch: {
        item: {
            handler() {
                this.$emit('input', this.item);
            },
            deep: true
        }
    },

    mounted() {
        this.item = { ...this.value };
    },

    methods: {
        getError(key) {
            return this.$getValidationErrorMessageHandler.handle(
                this.validation.item,
                this.serverErrors,
                key
            );
        }
    }
};
</script>
